export default __webpack_public_path__ + "static/media/storx-logo-icon.6a2305d4.svg";